import * as React from 'react';
import { useSelector } from 'react-redux';

import { SelectionsButton } from '../../components/SelectionsButton';
import { trackSelectionButtonClick } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingSelectionsUrl } from '../../utils/config';
import { HeaderCall } from '../Call';
import { getFromDeveloperPropsCount } from '../../selectors/newbuildingInfo';

export function ActionButtonContainer(): React.JSX.Element {
  const { config } = useApplicationContext();
  const fromDevelopersProps = Boolean(useSelector(getFromDeveloperPropsCount));
  const selectionsUrl = getNewbuildingSelectionsUrl(config);

  const onSelectionsButtonClick = React.useCallback(() => {
    trackSelectionButtonClick();
  }, []);

  if (!fromDevelopersProps) {
    return <SelectionsButton onClick={onSelectionsButtonClick} href={selectionsUrl} />;
  }

  return <HeaderCall eventAction="Open_jk_blockReviewsStickyHeader" />;
}
